var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowBlankReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 132,
    viewBox: "0 0 189 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6703 1.72095C14.1388 -2.85082 25.0418 53.0223 58.7998 88C103.672 134.493 187.575 130.926 187.575 130.926M13.6703 1.72095C21.9371 12.0725 34.5 24.9049 50.0434 31.1929M13.6703 1.72095C13.7428 17.5929 11.4601 31.1929 1.10083 45.5119",
    stroke: "#339EEC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlankReport);
export default __webpack_public_path__ + "static/media/ArrowBlankReport.cad75542cc91781991c075a0b092ebad.svg";
export { ForwardRef as ReactComponent };